import { Component, Host, Input, OnInit, Optional } from '@angular/core';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'gcc-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {
  @Input() public placeholder;
  public viewValue: string = null;
  get empty(): boolean {
    return !this.viewValue;
  }
  constructor(@Host() @Optional() public picker: BsDatepickerDirective) {}

  public ngOnInit(): void {
    this.placeholder = this.placeholder || this.picker?._config.dateInputFormat;
  }
}
